import { render, staticRenderFns } from "./AccountSidebarMenu.vue?vue&type=template&id=717ac015&"
import script from "./AccountSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports